module.exports = __webpack_public_path__ + "assets/09fe760c3a934b1d52b750f900b0a8fa.png";